// Every alert and all clear the site's ops tablet sent, and what Apple and Google said.

import { api } from '../../api.ts';
import { LEVELS, when } from '../../format.ts';
import type { AlertRow } from '../../types.ts';
import { Loading, Problem, useLoad } from '../../ui.tsx';

export function Alerts({ siteId }: { siteId: string }) {
  const { data, error, loading } = useLoad(() => api<{ alerts: AlertRow[] }>('GET', `/sites/${siteId}/alerts`), [siteId]);
  const cols = { gridTemplateColumns: '150px 200px 140px minmax(0, 1fr) minmax(0, 1.4fr)' };
  return (
    <div className="stack">
      {error && <Problem text={error} />}
      {loading && !data && <Loading />}
      {data && (
        <div className="table">
          <div className="tr th" style={cols}>
            <span>Sent</span>
            <span>Level</span>
            <span>Zones</span>
            <span>Sent from</span>
            <span>Delivered</span>
          </div>
          {data.alerts.length === 0 && <div className="empty">No alerts sent yet.</div>}
          {data.alerts.map((a) => {
            const lv = LEVELS[a.level] ?? { name: a.level, colour: 'var(--text2)' };
            const trouble = a.failed + a.unregistered;
            return (
              <div key={a.alertId} className="tr" style={cols}>
                <span className="mono muted">{when(a.issuedAt)}</span>
                <span className="row" style={{ gap: 8 }}>
                  <span className="dot" style={{ background: lv.colour }} />
                  {a.test ? 'Monthly test' : lv.name}
                </span>
                <span>{a.zones.join(', ')}</span>
                <span className="muted">{a.tabletLabel ?? 'Ops tablet'}</span>
                <span>
                  {!a.sentAt && a.attempted === 0 ? (
                    <span className="amber">Not sent to phones yet</span>
                  ) : a.attempted === 0 ? (
                    <span className="faint">No phones yet</span>
                  ) : (
                    <>
                      {a.accepted} of {a.attempted} phones
                      {trouble > 0 && <span className="amber"> · {trouble} not reached{a.sentAt ? '' : ' yet, still trying'}</span>}
                    </>
                  )}
                </span>
              </div>
            );
          })}
        </div>
      )}
      <p className="faint small">Delivered means Apple or Google accepted it for that phone. Only the Acknowledge add-on can show a phone actually rang.</p>
    </div>
  );
}
